import { Loader2 } from 'lucide-react';

import { DoneIcon } from '@/components/icons/done';
import FreezeIcon from '@/components/icons/freeze';

export const renderStatusIcon = (status: string) => {
  switch (status) {
    case 'Завершено':
      return <DoneIcon className="w-3.5 h-3.5 text-[#22c55e]" />;
    case 'В процессе':
      return <Loader2 className="w-4 h-4 text-[#8de227]" />;
    case 'Заморожено':
      return <FreezeIcon className="w-4 h-4" color="#505CFF" />;
    case 'Заброшен':
      return (
        <svg className="w-3.5 h-3.5 fill-gray-400" viewBox="0 0 24 24">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
        </svg>
      );
    default:
      return <Loader2 className="w-4 h-4 text-[#8de227]" />;
  }
};
